
import state from './../../zviz2/zviz/state';
import {default as Path, Controller as PathController} from './../../zviz2/zviz/components/path';
import {extend} from './../../zviz2/zviz/functions';

//import {LifeCycle} from './../zviz2/zviz/cycle';


class Controller extends PathController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);
        
    }

    setRenderOutput(output){
        super.setRenderOutput(output);
        output.result.setAttribute('d', this.blueprint.private.path);
    }

    reset(blueprint, renderer=null){
        super.reset(blueprint, renderer);
        if(this.renderOutput && this.renderOutput.result){
            this.renderOutput.result.setAttribute('d', this.blueprint.private.path);
        }
    }

    isHovered(){
        let hover = state.get('map.itemHover');
        if(hover){
            let dim = hover[0];
            let value = this.parent.mapValue(dim, hover[1]);
            
            let data = this.parent.countryData.get(this.data.id);
            if(data[dim] && data[dim] == value){
                return true;
            }
        }
        return false;
    }

    getOpacity(){
        let hover = state.get('map.itemHover');
        if(hover && hover[0] == 'region' || hover[0] == 'country'){
            return this.isHovered()? 1: 0.7;
        }
        return 1;
    }

} 


let Blueprint = extend({
    type: Controller,
    listeners: [
        (ctrl) => ( ctrl.addListener(state, [ctrl, ctrl.update], 'map.transformation.scale') )
    ],
    properties: {
        style:{
            fill: 'url(#mapGradient)',
            stroke: 'rgba(255,255,255,0.6)',
            strokeWidth: () => ((0.5 / (state.get('map.transformation.scale') || 1)) + 'px'),
            fillOpacity: (ctrl) => (ctrl.getOpacity() )
        },
        attributes: {
            //path: (ctrl) => ( ctrl.blueprint.private.path )
        }
    },
    children: [
       
    ],
    events: {

    }
}, Path);


export default Blueprint;
export {Controller, Blueprint};

